<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<section epub:type="division">
<div class="block">
<p class="hanging" id="fm"><span epub:type="pagebreak" id="page_1" title="1"></span>Hear this, ye old men,</p>
<p class="hanging">and give ear, all ye inhabitants of the land.</p>
<p class="hanging">Hath this been in your days,</p>
<p class="hanging">or even in the days of your fathers?<br/><br/></p>
<p class="hanging">Tell ye your children of it,</p>
<p class="hanging">and let your children tell their children,</p>
<p class="hanging">and their children another generation.</p>
<p class="extract"><strong><span class="small">BOOK OF JOEL</span></strong></p>
<p class="nonindent"><span class="small">CHAPTER ONE, VERSES 2 AND 3</span></p>
</div>
<figure>
<img alt="" src="OEBPS/images/1-1.jpg" style="width: 35%;"/>
<figcaption><span class="hlink" href="#/OEBPS/9780795346743_epub_c07_r1#link-1" title="Link target outside of Sample">A group of Jews from Berehovo, Ruthenia</span>, shortly after reaching Auschwitz, and before being sent to the gas chambers, photographed by an SS Sergeant.</figcaption>
</figure>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795346743_epub_fm_r1.vue?86ed806c